<template>
  <v-container>
    <v-layout row align-center>
      <v-flex>
        <div class="row">
          <div class="selector_chainlink empty">
            <div class="i-v-input">
              <span class="label">Empty</span>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'Empty',
  props: ['x', 'y'],
  data: () => ({}),
  methods: {},
  computed: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selector/Empty.vue